import {createSelector} from 'reselect';
import getAlipayPlusWalletIcons from './getAlipayPlusWalletIcons';

export default createSelector(
  [getAlipayPlusWalletIcons],
  icons => !!(Object.keys(icons)?.length && Object.keys(icons)?.length !== 0),
);
